export default __webpack_public_path__ + "static/media/rating_web-sm@1x.871da16b.jpg";